// Core
import React from "react";

function Question(props) {
   const { id, pre_text, question, top_text, type, options, bottom_text } = props.qOjb;
   const { newTarget, currentTarget } = props;

   return (
      <>
         <p dangerouslySetInnerHTML={{ __html: pre_text }}></p>
         <h4 className="text-primary" dangerouslySetInnerHTML={{ __html: question }}></h4>
         <p dangerouslySetInnerHTML={{ __html: top_text }}></p>

         {options.map((option, i) => {
            const uuid = id + "_" + i;
            return (
               <label className="questionBox" key={uuid}>
                  <span dangerouslySetInnerHTML={{ __html: option.text }} className="text-primary"></span>
                  <input
                     type="radio"
                     id={uuid}
                     name={`options_${id}`}
                     data-target={option.target}
                     defaultChecked={option.target === currentTarget ? true : false}
                     onClick={(e) => {
                        newTarget(e.target.dataset.target);
                     }}
                  />
                  <span className={"checkmark " + type}></span>
               </label>
            );
         })}

         {bottom_text && (
            <div className="mt-4 pt-4" style={{ borderTop: "1px dashed var(--bs-gray-300)" }}>
               <p dangerouslySetInnerHTML={{ __html: bottom_text }}></p>
            </div>
         )}
      </>
   );
}

export default Question;
